// Trial-session (the exam / placement-test lead-gen funnel) determination.
//
// A "trial session" is signalled by ?trial=true or an isTrial activity page (exam-* /
// placement-test). It marks lead-gen conversations for analytics and drives the client-side
// free-trial daily cap (see trialLimits.js). It is intentionally a soft, client-only concept —
// there is no server-side enforcement.
//
// The flag is sticky in localStorage so it survives in-iframe navigation that drops ?trial. It is
// cleared when a real (non-anonymous) user signs in — see onAuthStateChanged in firebase.js.
//
// This module is intentionally free of firebase imports so both firebase.js and the React layer
// can use it without a circular dependency.

import { getUrlParameter } from './urlUtils';

const STORAGE_KEY = 'trialSession';

// Is the current session a trial (exam/placement) session?
// `activityConfig` is optional: pass it on the activity pages so an isTrial activity counts
// even before the sticky flag or ?trial param is present.
export const isTrialSession = (activityConfig = null) =>
  getUrlParameter('trial') === 'true'
  || activityConfig?.isTrial === true
  || localStorage.getItem(STORAGE_KEY) === 'true';

// Persist the sticky trial flag when the current session is a trial. Call once at session entry.
// Returns whether it is a trial session so callers can branch off the result.
export const markTrialSessionIfNeeded = (activityConfig = null) => {
  const trial = isTrialSession(activityConfig);
  if (trial) localStorage.setItem(STORAGE_KEY, 'true');
  return trial;
};
